import "bootstrap/dist/css/bootstrap.min.css";
import React, { useState } from "react";
import { Col, Row, Toast, ToastContainer } from "react-bootstrap";
import { commonStrings } from "../../../../../../core";
import { NavbarLinks, PartsList } from "../../../../../../ds";
import {
  SearchContentProps
} from "../../../../business";

export const SearchContent: React.FC<SearchContentProps> = ({ data }) => {
  const cs = commonStrings().PTBR;
  const [toasting, setToasting] = useState<string | null>(null);

  return (
    <>
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <NavbarLinks cs={cs} />
          <Row>
            <Col xs={12} sm={12} md={12} lg={12} className={"pt-3"}>
              <PartsList title={`${data.length} produtos encontrados`} items={data} />
            </Col>
          </Row>
        </Col>

      </Row>
      <ToastContainer position="bottom-center" className="p-3" style={{ zIndex: 1 }}>
        <Toast
          bg={"danger"}
          onClose={() => setToasting(null)}
          show={toasting !== null ? true : false}
          delay={5000}
          autohide
        >
          <Toast.Body className={"text-white"}>
            {toasting !== null ? toasting : null}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};
